export const getWebPUrlWithWidth = (url: string, width: number) => {
  const webpUrl = new URL(url);
  webpUrl.searchParams.set('fm', 'webp');
  webpUrl.searchParams.set('w', width.toString());
  return webpUrl.toString();
};
